import { configureStore } from '@reduxjs/toolkit';

import { services2 } from '/api/services2';
import { buzzerAppNotifications } from '/common/buzzer';

import { reducer } from './reducer';
import { systemRehydrate } from './systemActions';
import { logout } from './toolkits/auth/actions';
import { deviceSocketMiddleware } from './middleware/deviceSocketMiddleware';
import { listenerMiddleware } from './listenerMiddleware';

// Import listeners to initialize them
import './listener';

const prod = __CI_BRANCH__ === 'master';

export const store = configureStore({
  reducer,
  devTools: !prod,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(listenerMiddleware.middleware).concat(deviceSocketMiddleware),
});

buzzerAppNotifications.init(store);

services2.transport.onFailureEx = ({ code }) => {
  if (code === 401) {
    store.dispatch(logout());
  }
};

// rehydrate the store
store.dispatch(systemRehydrate());
